module.exports = __webpack_public_path__ + "static/media/1f949.141a8dae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f949.svg
// module id = 625
// module chunks = 1